import React, { useEffect, useState } from "react";
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources } from "../authConfig";
import { MyEmployeesForm } from "./MyEmployeesForm";
import Card from '@mui/material/Card';
import { MyEmployeesGrid } from "./MyEmployeesGrid";
import { usePosition } from '../hooks/usePosition';
import LoadingSpinner from "./LoadingSpinner";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const customId = "custom-id-yes";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Button } from "react-bootstrap";
import Collapse from '@mui/material/Collapse';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const MyEmployeesView = (props) => {

    const { latitude, longitude } = usePosition();

    const [attendance, setAttendance] = useState(null);
    const [adminData, setAdminData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [showAllEmployees, setShowAllEmployees] = useState(false);

    const { error, isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.api.scopes
    });

    const toggleFilter = () => setShowFilter(!showFilter);

    useEffect(() => {
        if (!adminData) {
            execute("GET", protectedResources.api.administrator)
                .then((response) => {
                    if (response?.data) {
                        setAdminData(response.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching administrator:", error);
                });
        }
    }, [execute, adminData]);

    const handleSelectJustificar = (attendance) => {
        if(attendance){
            setAttendance(attendance);
        }else{
            setAttendance(null);
        }  
    };

    const handleRequestJustificar = (excuse) => {
        excuse.latitude = latitude;
        excuse.longitude = longitude;
        execute("POST", protectedResources.api.excuses, excuse).then((response) => {
            if (response && response.status == 200) {
                setAttendance(null);
            }
        }).catch((error) => {
            console.log(error);

        });
    }

    if (error) {
        toast.error(error.message, {
            toastId: customId,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }
    const renderForm = (
        <>
            {adminData?.isAdmin && (
                <Card variant="outlined" className="mb-3">
                    <Button
                        className="filterHeaderButton"
                        onClick={toggleFilter}
                        style={{
                            width: '100%',
                            padding: '10px 16px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            border: 'none',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                            textAlign: 'left'
                        }}
                    >
                        <span style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.6)' }}>
                            Filtros
                        </span>
                        <i
                            className={`fa fa-angle-down ${showFilter ? 'rotated' : ''}`}
                            style={{
                                transition: 'transform 0.2s ease',
                                color: 'rgba(0, 0, 0, 0.6)'
                            }}
                        />
                    </Button>
                    <Collapse in={showFilter}>
                        <div style={{ padding: '16px' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showAllEmployees}
                                        onChange={(e) => setShowAllEmployees(e.target.checked)}
                                    />
                                }
                                label="Mostrar todos los empleados (no solo mis subordinados)"
                            />
                        </div>
                    </Collapse>
                </Card>
            )}
            <Card variant="outlined">
                <h2 className="tituloH2 mt-3">Registro de inasistencias</h2>
                {!attendance && (
                    <MyEmployeesGrid
                        handleSelectJustificar={handleSelectJustificar}
                        showAll={showAllEmployees}
                        isAdmin={adminData?.isAdmin}
                    />
                )}
                {attendance && <MyEmployeesForm handleSelectJustificar={handleSelectJustificar} attendance={attendance} handleRequestJustificar={handleRequestJustificar} />}
            </Card>
        </>
    );

    return (
        <div className="container"> {isLoading ? <LoadingSpinner /> : renderForm}</div>
    );
}
